import { AwsCognitoConfig } from './types/types';

export const awsConfig: AwsCognitoConfig = {
  aws_project_region: 'us-east-1',
  aws_cognito_identity_pool_id: null,
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_9GE0miqs9',
  aws_user_pools_web_client_id: '8k37inqddmmlf1140pquh9vpr',
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL', 'FAMILY_NAME', 'GIVEN_NAME'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: process.env.REACT_APP_AWS_S3_BUCKET,
  aws_user_files_s3_bucket_region: 'us-east-1',
};
